<template>
    <InformeCard id="ocupacion" name="ocupacion" collapsable="true" title="Ocupación"
        v-if="sesiones && sesiones.length === 1">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Zona</th>
                        <th>Aforo máximo</th>
                        <th>Confirmados / Butacas cerradas</th>
                        <th>% ocupación</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(seccion, index) in secciones">
                        <tr :key="index">
                            <td>{{ seccion.name }}</td>
                            <td>{{ seccion.aforo }}</td>
                            <td>{{ seccion.butacas_ocupadas }}</td>
                            <td>
                                {{ porcentaje_ocupacion(seccion.butacas_ocupadas, seccion.aforo) + ' %' }}
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="1">TOTAL</td>
                        <td>{{ total_aforo() }}</td>
                        <td>{{ total_butacas_ocupadas() }}</td>
                        <td>{{ media_ocupacion() + ' %' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['event_id', 'sesiones'],
    data() {
        return {
            secciones: null
        }
    },
    mounted() {
        const params = {
            filters: {},
            evento_id: this.event_id,
            sesion_id: this.sesiones[0].id
        };
        this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.informe.ocupacion'), params).then(res => {
            this.secciones = res.data.sectores;
        });
    },
    methods: {
        porcentaje_ocupacion(confirmados, total) {
            if (total === 0) {
                return 0;
            }
            return parseFloat((confirmados / total * 100).toPrecision(2));
        },
        total_aforo() {
            var resultado = 0;

            if (this.secciones) {
                this.secciones.forEach(seccion => {
                    resultado += parseInt(seccion.aforo);
                });
    
                return resultado;
            }

            return resultado;
        },
        total_butacas_ocupadas() {
            var resultado = 0;

            if (this.secciones) {
                this.secciones.forEach(seccion => {
                    resultado = resultado + seccion.butacas_ocupadas;
                });
    
                return resultado;
            }

            return resultado;
        },
        media_ocupacion() {
            var resultado = 0;

            if (this.secciones) {
                this.secciones.forEach(seccion => {
                    resultado += this.porcentaje_ocupacion(seccion.butacas_ocupadas, seccion.aforo);
                });

                var media = (resultado / this.secciones.length).toFixed(2);
    
                if (media >= 0) {
                    return media;
                } else {
                    return 0;
                }
            }

            return resultado;
        }
    },
    components: {
        InformeCard
    }
}
</script>